// src/components/WhatsAppWidget.js
import React from "react";
import { FaWhatsapp } from "react-icons/fa";

function WhatsAppWidget() {
  const phoneNumber = "254113266213"; // Replace with your phone number (no + sign)

  return (
    <a
      href={`https://wa.me/${phoneNumber}`}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-5 right-5 bg-green-500 text-white p-4 rounded-full shadow-lg hover:bg-green-600 z-50"
      title="Chat with us on WhatsApp"
    >
      <FaWhatsapp className="text-2xl" />
    </a>
  );
}

export default WhatsAppWidget;
